export const ORDER_EVENT_TOPICS = ["orders", "supplier-orders", "notifications", "consignment"] as const;
export type OrderEventTopic = (typeof ORDER_EVENT_TOPICS)[number];

// These envelopes stay on the server. The browser only receives topic names.
export type OrderChange =
  | { scope: "staff"; topic: "orders" | "supplier-orders" }
  | { scope: "order"; topic: "orders"; companyId: string; userId: string }
  | { scope: "source_company"; topic: "consignment"; companyId: string }
  | { scope: "user"; topic: "notifications"; userId: string };

export const ORDER_EVENT_CHANNEL = "cfmoto_order_changes";

export function parseOrderChange(payload: string | undefined): OrderChange | null {
  if (!payload || payload.length > 2_000) return null;
  try {
    const value: unknown = JSON.parse(payload);
    if (!value || typeof value !== "object" || Array.isArray(value)) return null;
    const event = value as Record<string, unknown>;
    const id = (value: unknown): value is string =>
      typeof value === "string" && value.length > 0 && value.length <= 256;
    if (event.scope === "staff" && (event.topic === "orders" || event.topic === "supplier-orders")) {
      return { scope: "staff", topic: event.topic };
    }
    if (event.scope === "order" && event.topic === "orders" && id(event.companyId) && id(event.userId)) {
      return { scope: "order", topic: "orders", companyId: event.companyId, userId: event.userId };
    }
    if (event.scope === "user" && event.topic === "notifications" && id(event.userId)) {
      return { scope: "user", topic: "notifications", userId: event.userId };
    }
    if (event.scope === "source_company" && event.topic === "consignment" && id(event.companyId)) {
      return { scope: "source_company", topic: "consignment", companyId: event.companyId };
    }
    return null;
  } catch {
    return null;
  }
}
